import React from 'react';
import styled from 'styled-components';
import Badge from '../Badge';
import { theme } from '../../styles/theme';

interface IProps {
  title: string;
  isBeta?: boolean;
  warningMessage?: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 16px;
  border-bottom: 1px solid ${theme.colors.border};
`;
const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
  color: ${theme.colors.secondary900};
  display: flex;
  column-gap: 8px;
  flex: 0 0 auto;
  flex-direction: row;
`;
const StyledBetaBadge = styled(Badge)`
  margin-top: 4px;
`;

const WarningMessage = styled.span`
  color: ${theme.colors.red500};
`;

export default ({ title, isBeta, warningMessage }: IProps) => (
  <Container>
    <Title>
      <span>{title}</span>
      {isBeta && (
        <StyledBetaBadge color="purple" size="secondary">
          BETA
        </StyledBetaBadge>
      )}
    </Title>

    {warningMessage && <WarningMessage>{warningMessage}</WarningMessage>}
  </Container>
);
